"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.guardianshipPersonaFactory = void 0;
const Factory = require("factory.ts");
const persona_1 = require("../../../../mocks/persona");
exports.guardianshipPersonaFactory = Factory.Sync.makeFactory({
    id: persona_1.persona.id,
    uuid: 'abc-123',
    name: persona_1.persona.full_name
});
